import { CheckboxFilter } from '../CheckboxFilter/CheckboxFilter'
import { RadioFilter } from '../RadioFilter/RadioFilter'
import { FilterTypeCheckboxProps } from '../types'
import { Option } from '../../Form/types'

export type SelectFilterProps = {
    multiple?: boolean
    renderLabel?: (option: Option) => React.ReactNode
} & FilterTypeCheckboxProps

export const SelectFilter: React.FC<SelectFilterProps> = (props) => {
    const { multiple = true, ...passedProps } = props

    if (multiple) {
        return <CheckboxFilter {...passedProps} />
    }

    return (
        <RadioFilter
            {...passedProps}
            onChange={(value: unknown) => {
                if (typeof value === 'string') {
                    props.onChange([value])
                }
            }}
            value={props.value[0]}
            defaultValue={props.defaultValue[0]}
        />
    )
}
